import React from 'react';
import './CabinetZdoParents.css';

const ReceptionQueue = () => {
  // Данные очереди (в реальном приложении будут приходить из API)
  const queueData = [
    { id: 1, date: '23.07.2025', topic: 'Розгляд документів', name: 'Ліна Василівна Костенко', phone: '380668889980', status: 'planned' },
    { id: 2, date: '24.07.2025', topic: 'Затвердження документів', name: 'Іван Петрович Франко', phone: '380669990123', status: 'planned' },
    { id: 3, date: '25.07.2025', topic: 'Передача документів', name: 'Оксана Дмитрівна Забужко', phone: '380660011223', status: 'planned' },
    { id: 4, date: '26.07.2025', topic: 'Оцінка документів', name: 'Григорій Сковорода', phone: '380661122334', status: 'done' },
    { id: 5, date: '27.07.2025', topic: 'Підписання документів', name: 'Марія Іванівна Монтене', phone: '380662233445', status: 'done' },
    { id: 6, date: '26.07.2025', topic: 'Оцінка документів', name: 'Григорій Сковорода', phone: '380661122334', status: 'canceled' },
    { id: 7, date: '27.07.2025', topic: 'Підписання документів', name: 'Марія Іванівна Монтене', phone: '380662233445', status: 'done' },
    { id: 8, date: '27.07.2025', topic: 'Оцінка документів', name: 'Григорій Сковорода', phone: '380661122334', status: 'canceled' },
    { id: 9, date: '27.07.2025', topic: 'Підписання документів', name: 'Марія Іванівна Монтене', phone: '380662233445', status: 'done' },
    { id: 10, date: '27.07.2025', topic: 'Підписання документів', name: 'Марія Іванівна Монтене', phone: '380661122334', status: 'done' }
  ];

  // Функция для получения класса статуса
  const getStatusClass = (status) => {
    switch (status) {
      case 'planned': return 'planned';
      case 'done': return 'done';
      case 'canceled': return 'canceled';
      default: return '';
    }
  };

  // Функция для отображения текста статуса
  const getStatusText = (status) => {
    switch (status) {
      case 'planned': return 'Заплановано';
      case 'done': return 'Проведено';
      case 'canceled': return 'Скасовано';
      default: return '';
    }
  };

  return (
    <main className="main-content parents-page">
      <div className="container-fluid">
        <div className="content-wrapper">
          <div className="card">
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table parents-table align-middle mb-0">
                  <thead>
                    <tr>
                      <th style={{ width: '70px' }}>№</th>
                      <th style={{ width: '150px' }}>Дата</th>
                      <th>Тема</th>
                      <th>Ім'я, по батькові, прізвище</th>
                      <th style={{ width: '180px' }}>Телефон</th>
                      <th style={{ width: '160px' }}>Статус</th>
                    </tr>
                  </thead>
                  <tbody>
                    {queueData.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.date}</td>
                        <td>{item.topic}</td>
                        <td>{item.name}</td>
                        <td>{item.phone}</td>
                        <td>
                          <span className={`status-badge ${getStatusClass(item.status)}`}>
                            {getStatusText(item.status)}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ReceptionQueue;